import { createFileRoute } from '@tanstack/react-router'
import { ApVendorDetailPage } from '@/pages/ap-vendor-detail'

export const Route = createFileRoute('/_authenticated/ap-vendors/$vendorId')({
  staticData: { title: 'AP Vendor' },
  component: ApVendorDetailRoute,
})

function ApVendorDetailRoute() {
  const { vendorId } = Route.useParams()
  return <ApVendorDetailPage vendorId={vendorId} />
}
